import { styled, Typography } from '@mui/material';
import { Modal } from '../../../../components/Modal';

function DisclaimerModal(props: { isOpen: boolean; close: () => void }) {
    return (
        <Modal
            isOpen={props.isOpen}
            close={props.close}
            onConfirm={props.close}
            size="small"
            title="Récapitulatif de formulaire de droit à l'image"
            confirmButtonLabel="J'ai compris"
        >
            <TextContainer>
                <p>Votre formulaire de droit à l'image a bien été envoyé à l'administration.</p>
                <p>Vous pouvez sauvegarder le récapitulatif sur cette page.</p>
            </TextContainer>
        </Modal>
    );
}

const TextContainer = styled(Typography)(({ theme }) => ({}));

export { DisclaimerModal };
